import * as React from "react";
import { connect } from "react-redux";

import { verifyOTP,resendverifyOTP } from "./action";

import VerifyOTP from "../../screens/VerifyOTP";

class VerifyOTPContainer extends React.Component<Props, State> {
  render() {
    return <VerifyOTP 
        verifyOTP={this.props.verifyOTP} 
        resendverifyOTP={this.props.resendverifyOTP}
      />;
  }
}
function bindAction(dispatch) {
  return {
    verifyOTP: (value) => {
      dispatch(verifyOTP(value));
    },
    resendverifyOTP:(value)=>{
      dispatch(resendverifyOTP(value));
    },
  };
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, bindAction)(VerifyOTPContainer);
